const ge = {
    "Bütün Kateqoriyalar": "Ყველა კატეგორია",
    "Kateqoriyalar": "კატეგორიები",
    "Kateqoriya": "კატეგორია",
    "Alətlər": "ინსტრუმენტები",
    "Elektronika": "ელექტრონიკა",
    "Nişan & Toy": "ჩართულობა & ქორწილი",
    "Geyim": "Ტანსაცმელი",
    "Ev & Mətbəx": "მთავარი & სამზარეულო",
    "Oyuncaqlar & Oyunlar": "სათამაშოები & თამაშები",
    "İdman malları": "სპორტი",
    "Musiqi": "მუსიკა",
    "DVDS & Video oyunlar": "DVD & Ვიდეო თამაშები",
    "Qarışıq": "სხვადასხვა",
    "Çanta": "ჩანთა",
    "Velosiped": "Ველოსიპედი",
    "İdman Geyimi": "Სპორტული სამოსი",
    "5 AZN / həftəlik": "5 AZN / ყოველკვირეული",
    "15 AZN / həftəlik": "15 AZN / ყოველკვირეული",
    "20 AZN / həftəlik": "20 AZN / ყოველკვირეული",
    "ALMA!": "არ იყიდოთ",
    "Məhsulu axtarın..": "მოძებნეთ ნივთი..",
    "Məhsulu axtarın": "მოძებნეთ ნივთი",
    "İCARƏYƏ GÖTÜR": "ქირავდება საქონელი",
    "İcarəyə götür": "ქირავდება საქონელი",
    "İCARƏYƏ VER": "დამატება",
    "İcarəyə ver": "დამატება",
    "Hamısına Bax": "იხილეთ ყველა",
    "Bizi izləyin": "Მოგვყევი",
    "Bütün hüquqlar qorunur": "Ყველა უფლება დაცულია",
    "Günlük": "1 დღე",
    "Əsas səhifə": "საწყისი გვერდი",
    "məhsul tapıldı": "ნაპოვნია ნივთი",
    "Çeşidlə": "Დალაგება",
    "Qiymətə görə (əvvəlcə ucuz)": "ფასი (დაბალიდან მაღალი)",
    "Qiymətə görə (əvvəlcə bahalı)": "ფასი (მაღალიდან დაბალამდე)",
    "Hamısı": "ყველა",
    "Qiymət": "ფასი",
    "Filtiri təmizlə": "გაასუფთავეთ ფილტრები",
    "Yeni elan yerləşdir": "ახალი რეკლამა",
    "Siyahıdan seçin": "აირჩიეთ სიიდან",
    "Şəhər": "ქალაქი",
    "Məzmun": "აღწერა",
    "simvol qalıb": "სიმბოლოები",
    "Şəkillər": "სურათები",
    "Şəkil əlavə et": "სურათის დამატება",
    "Şəkilin ölçüsü 3096kb-dan çox olmamalıdır.": "სურათის ზომა უნდა იყოს 3096 კბ -ზე ნაკლები.",
    "Əlaqə məlumatları": "Საკონტაქტო ინფორმაცია",
    "Adınız": "სახელი",
    "Mobil nömrə": "მობილიზება",
    "Elanı yerləşdir": "განათავსეთ რეკლამა",
    "Bağışlayın, seçdiyiniz kriteriya üzrə heç bir məhsul tapılmadı": 
    "უკაცრავად, თქვენს მიერ არჩეული კრიტერიუმების შედეგები არ მოიძებნა",
    "Ətraflı Bax": "Იხილეთ დეტალები",
    "Axtar": "ძებნა",
    "İcarə": "Ქირავდება",
    "Satış": "იყიდე",
    "Həftəlik": "7 დღე",
    "Məsul şəxs": "Საკონტაქტო პირი",
    "Mobil": "Მობილურის ნომერი",
    "İcarə qiyməti": "ქირა ფასი",
    "Satış qiyməti": "Გასაყიდი ფასი",   
};

export default ge;